module.exports = __webpack_public_path__ + "static/media/timeBullet.e572df60.svg";